module.exports = "/assets/58a8dd07fd7c1bd1abc3016502423407.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/NX.png
// module id = 1662
// module chunks = 0